<template>
	<div class="inline-modal-wrapper" v-bind:class="{ 'inline-modal-open': isOpen }">
		<div class="inline-modal-container">
			<div class="inline-modal-content" v-if="isOpen" v-on:click.prevent="overlayClick($event)" ref="overlay">
				<div class="inline-modal-inner" ref="overlayInner">
					<div class="inline-modal-inner-wrapper">
						<div class="inline-modal-top-action">
							<h4 class="type-h4 truncate-no-wrap inline-modal-title" v-if="headerText.length > 0" v-html="headerText"></h4>
							<button type="button" class="type-large" v-on:click.prevent="modalToggle">
								<img src="/images/icon-close.svg" alt="Close icon" />
							</button>
						</div>
						<div class="inline-modal-inner-content">
							<!-- we use a slot here so that the content still exists on the page and we dont need to
								call an API to get this info. Better for SEO and better for page performance -->
							<slot>
								<p class="type-bold color-red">Slot for "content" is required</p>
							</slot>
						</div>
						<div class="inline-modal-bottom-action">
							<button type="button" class="btn btn--tertiary" v-text="closeText" v-on:click.prevent="modalToggle"></button>
						</div>
					</div>
				</div>
			</div>
			<div class="inline-modal-button">
				<button type="button" v-bind:class="buttonClass" v-text="buttonText" v-on:click.prevent="modalToggle" ref="close"></button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'InlineModal',
		props: {
			buttonClass: {
				required: false,
				type: String,
				default: 'btn btn--full btn--border-black btn--secondary btn--padding-light add-bottom-margin',
			},
			buttonText: {
				required: true,
				type: String,
			},
			headerText: {
				required: false,
				type: String,
				default: '',
			},
			closeText: {
				required: false,
				type: String,
				default: 'Close',
			},
		},
		data() {
			return {
				isOpen: false,
			}
		},
		mounted() {
			document.addEventListener('keydown', this.handleEscPress);
		},
		destroyed() {
			document.removeEventListener('keydown', this.handleEscPress);
		},
		methods: {
			handleEscPress(evt) {
				evt = evt || window.event;
				// 27 == "Esc"
				if (evt.keyCode == 27 && this.isOpen) {
					this.isOpen = false;
				}
			},
			modalToggle() {
				this.isOpen = !this.isOpen;
				if (this.isOpen) {
					// focus the close icon for keyboard accessibility
					this.$nextTick(() => this.$refs.close.focus());
				}
			},
			overlayClick(event) {
				// we only care about explicit clicks on the overlay or the clipped padding on the modal
				if(event.target !== this.$refs.overlay && event.target !== this.$refs.overlayInner) {
					return;
				}

				this.isOpen = false;
			},
		},
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/InlineModal.vue